import type { Editor, NodeEntry } from 'slate';
import { Transforms } from 'slate';

import { mergeWithDefaults } from '../../../util';
import type { HeadersElement } from '../../internal';
import { createDefaultHeaders } from '../../internal';

export function normalizeHeadersPart(
  editor: Editor,
  headersPartEntry: NodeEntry<HeadersElement>
): void {
  const [, headersPartPath] = headersPartEntry;
  if (headersPartPath.length > 1) {
    Transforms.moveNodes(editor, { at: headersPartPath, to: [editor.children.length] });
    return;
  }

  validateHeadersPartProps(editor, headersPartEntry);
}

function validateHeadersPartProps(
  editor: Editor,
  headersPartEntry: NodeEntry<HeadersElement>
): void {
  const [headersPart, headersPartPath] = headersPartEntry;
  const { children: headersPartChildren, ...headersPartProps } = headersPart;
  const { children: defaultHeadersPartChildren, ...defaultHeadersPartProps } =
    createDefaultHeaders();
  const missingKeys = Object.keys(defaultHeadersPartProps).some(propKey => {
    const hasKey = propKey in headersPart;
    return !hasKey;
  });
  const newProps: Omit<HeadersElement, 'children'> = mergeWithDefaults(
    headersPartProps,
    defaultHeadersPartProps
  );
  if (!missingKeys) return;

  Transforms.setNodes(editor, newProps, { at: headersPartPath });
}
